import { useEntities } from '@terminal/react-query-hooks/entities/useEntities';
import { useGraphRelations } from '@terminal/react-query-hooks/graph/useGraphRelations';
import { useTranslation } from 'react-i18next';
import { getDistributions } from './utils/utils';

export type SectorDistribution = {
  name: string;
  value: number;
};

export interface SectorDistributions {
  totalCompaniesCount: number;
  sectorDistributions: SectorDistribution[];
}

export const useFinancialSectorDistributions = ({
  themeId,
}: {
  themeId: string;
}) => {
  const { t } = useTranslation(['widget']);

  const {
    data,
    isFetching: isGraphConnectionsFetching,
    isError: isGraphConnectionsError,
  } = useGraphRelations({
    nodeType: 'theme',
    node: themeId,
    relationKind: 'theme-company',
    direction: 'outbound',
  });

  const themeCompanies =
    data?.nodes.flatMap(node =>
      node.attributes.type === 'company' && node.attributes.id
        ? [node.attributes.id]
        : []
    ) ?? [];

  const top30Tags = themeCompanies.slice(0, 30);

  const {
    data: entities,
    isLoading: isEntitiesLoading,
    isError: isEntitiesError,
  } = useEntities({
    entityTags: top30Tags,
    enabled: !!top30Tags.length,
  });

  const sectorDistributions = getDistributions(entities, t);

  return {
    data: {
      totalCompaniesCount: themeCompanies.length,
      sectorDistributions,
    },
    isFetching: isGraphConnectionsFetching || isEntitiesLoading,
    isError: isGraphConnectionsError || isEntitiesError,
  };
};
